import { UserStepText } from "./types";

export const USER_INFO_STEP = 0;
export const USER_ACCOUNT_STEP = 1;
export const USER_CONTACT_STEP = 2;
export const USER_SUMMARY_STEP = 3;

/** Naslov i objašnjenje ispod scene, po koraku; prvi i zadnji korak ovise o tome je li korisnik nov. */
export const USER_INTRO_TEXTS: Record<"create" | "edit", Record<number, UserStepText>> = {
  create: {
    [USER_INFO_STEP]: {
      title: "Dodajte novog korisnika",
      description: "Upišite ime, prezime i OIB. Po imenu se korisnik prepoznaje u cijelom sustavu.",
    },
    [USER_ACCOUNT_STEP]: {
      title: "Prijava i uloge",
      description: "Korisničko ime i lozinka služe za prijavu. Uloge određuju što korisnik u sustavu smije raditi.",
    },
    [USER_CONTACT_STEP]: {
      title: "Kako doći do korisnika?",
      description: "Upišite email i telefone korisnika. Email mora biti jedinstven u sustavu.",
    },
    [USER_SUMMARY_STEP]: {
      title: "Provjerite i spremite",
      description: "Pregledajte unesene podatke. Nakon spremanja korisnik se može prijaviti u sustav.",
    },
  },
  edit: {
    [USER_INFO_STEP]: {
      title: "Uredite podatke korisnika",
      description: "Ispravite ime, prezime ili OIB. Promjena se odmah vidi u cijelom sustavu.",
    },
    [USER_ACCOUNT_STEP]: {
      title: "Prijava i uloge",
      description: "Promijenite korisničko ime, lozinku ili uloge. Uloge određuju što korisnik u sustavu smije raditi.",
    },
    [USER_CONTACT_STEP]: {
      title: "Kako doći do korisnika?",
      description: "Ažurirajte email i telefone korisnika. Email mora biti jedinstven u sustavu.",
    },
    [USER_SUMMARY_STEP]: {
      title: "Provjerite i spremite",
      description: "Pregledajte promjene prije spremanja. Nakon spremanja promjene su odmah dostupne u sustavu.",
    },
  },
};

/** Primjeri dok korisnik ništa nije upisao. */
export const USER_INTRO_SAMPLE = {
  fullName: "Ana Kovačević",
  oib: "12345678901",
  userName: "ana.kovacevic",
  email: "ana.kovacevic@orytron.com",
  phone: "+385 1 234 5678",
  mobile: "+385 91 234 5678",
  roleNames: ["Prodaja", "Najam"],
  officeName: "Poslovnica Zagreb",
  team: ["MP", "IH", "LB"],
  summary: ["Osnovni podaci", "Korisnički podaci", "Kontakt"],
};
